import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import CampaignsList from "./CampaignsList";

import { observer } from "mobx-react";

class Campaigns extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    UNSAFE_componentWillMount() {
        this.props.store.setCurrentSection("campaigns");

        // Breadcrumbs
        this.props.store.setBreadcrumbs([{ title: "Campaigns" }]);
    }

    render() {
        return (
            <Switch>
                {/* <Route
                    path="/dashboard/competitors/:id/report"
                    //   render={props => (
                    //       // <CompetitorsReport
                    //       //     store={this.props.store}
                    //       //     {...props}
                    //       // />
                    //   )}
                /> */}
                <Route
                    render={props => (
                        <CampaignsList store={this.props.store} {...props} />
                    )}
                />
            </Switch>
        );
    }
}

export default observer(Campaigns);
